// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"3802d1ff","696":"95bfcfe1","730":"191dc693","787":"02b48111","839":"85b6ffbc","969":"4e72ef8b"}[chunkId] + ".chunk.js";
};